import { SchoolSoftImportType, SchoolSoftTargetSystem, SchoolSoftActivityNaming, SchoolSoftSensitiveFields } from '../../../../../../models/CoreSchoolSoftConfigurationModels';


export const importType: SchoolSoftImportType[] = [

    SchoolSoftImportType.Selected,
    SchoolSoftImportType.Hybrid,
    SchoolSoftImportType.Full,
    SchoolSoftImportType.HybridSS12000Activities
];


export const targetSystem: SchoolSoftTargetSystem[] = [
    SchoolSoftTargetSystem.Classroom, 
    SchoolSoftTargetSystem.Teams
];


export const activityNaming: SchoolSoftActivityNaming[] = [
    SchoolSoftActivityNaming.ActivityName, 
    SchoolSoftActivityNaming.GroupName,
    SchoolSoftActivityNaming.GroupWithActivityName
]; 

export const sensitiveField: SchoolSoftSensitiveFields[] = [

    SchoolSoftSensitiveFields.Address,
    SchoolSoftSensitiveFields.CivicNo,
    SchoolSoftSensitiveFields.PersonalEmail,
    SchoolSoftSensitiveFields.Custodians,
    SchoolSoftSensitiveFields.BirthDate,
    SchoolSoftSensitiveFields.PhoneNumber,
    SchoolSoftSensitiveFields.Sex
]; 
